export default "__VITE_ASSET__DfEyit8j__"